module.exports = __webpack_public_path__ + "static/media/youtubeIcon.9ec7674e.png";